import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// a plain PNG: the SVG export wrapped this picture in a pattern fill, which
// Safari sometimes painted as a black box (Devin 2026-10-29)
import logo from "../../Assets/logo-header.png";
import LogoutModal from "../../Components/Modals/LogoutModal/LogoutModal";
import ChangePasswordModal from "../../Components/Modals/ChangePasswordModal/ChangePasswordModal";
import "./HeaderOrg.css";
import { readDevice } from "../../device/deviceSession";

const HeaderOrg = () => {
    const [show, setShow] = useState(false)
    const [showChangePwd, setShowChangePwd] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const openSignOutModalHandler = () => {
        setShow(true)
    }

    const navigateToDashboardHandler = () => {
        localStorage.setItem("eventsTab", false)
        // navigate("/admin-dashboard")
        navigate("/")
    }

    // an event-day job device (card 540f21a4): what it is for, and its home
    const device = readDevice();
    if (device) {
        return (
            <div className="px-5 py-3 bg-grey-79 d-flex justify-content-between align-items-center">
                <div><img src={logo} className="feis-logo" alt="logo" onClick={() => navigate("/")} /></div>
                <div className="text-white cursor-pointer d-flex align-items-center" onClick={() => navigate("/")}>
                    {device.label ? `${device.label} · ` : ""}{device.roleName} · Device home
                </div>
            </div>
        );
    }

    return (
        <>
            {localStorage.getItem("accessToken") &&
                <div className="px-5 py-3 bg-grey-79 d-flex justify-content-between align-items center">
                    <div><img src={logo} className="feis-logo" alt="logo" onClick={navigateToDashboardHandler} /></div>
                    <div className="d-flex align-items-center" style={{ gap: "24px" }}>
                        <div className="text-white cursor-pointer d-flex align-items-center" onClick={() => setShowChangePwd(true)}>Change password</div>
                        <div className="text-white cursor-pointer d-flex align-items-center" onClick={openSignOutModalHandler}>Sign out</div>
                    </div>
                    {show && <LogoutModal setShow={setShow} show={show} />}
                    {showChangePwd && <ChangePasswordModal onClose={() => setShowChangePwd(false)} />}
                </div>
            }
        </>
    );
};

export default HeaderOrg;
